import React from "react";
import { useNavigate } from "react-router-dom";

const formatTimePlayed = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  let formattedTime = "";
  if (mins > 0) formattedTime += `${mins}min `;
  formattedTime += `${secs}s`;

  return formattedTime;
};

const GameHistory = ({ botInfo }) => {
  const navigate = useNavigate();

  if (botInfo.game_history.length==0) {
    return (
      <div className="p-6 rounded-lg shadow-lg space-y-8">
        <p className="text-white">No data.</p>
      </div>
    );
  }
  return (
    <div className="py-4 px-8">
      <h2 className="text-2xl font-bold pb-4 mb-4 text-center border-b border-gray-700">Game History</h2>
      <ul className="space-y-4">
        {botInfo.game_history.map((game, index) => {
          // Determine the opponent and result
          const opponent =
            game.bot_a.id === botInfo.bot.id ? game.bot_b : game.bot_a;
          const result =
            game.winner.id === botInfo.bot.id
              ? "WIN"
              : game.winner.id === null
              ? "DRAW"
              : "LOSS";

          // Choose styles for result
          const resultStyles = {
            WIN: "text-green-500 font-bold",
            LOSS: "text-red-500 font-bold",
            DRAW: "text-gray-400 font-bold",
          };

          // Choose background color for the game entry
          let backgroundColor;
          if (result === "WIN") {
            backgroundColor = "border-2 bg-green-600/20 border-green-600/60";
          } else if (result === "LOSS") {
            backgroundColor = "border-2 bg-red-600/20 border-red-600/60";
          } else {
            backgroundColor = "border-2 bg-gray-600/20 border-gray-600/60";
          }

          return (
            <li
              key={index}
              className={`flex items-center justify-center p-1 rounded-lg shadow-md ${backgroundColor}`}
            >
              {/* Bot A */}
              <div
                className="flex justify-end items-center cursor-pointer gap-x-2 w-36"
                onClick={() => navigate(`/profiles/${game.bot_a.twitch_display_name}/${game.bot_a.tag}`)}
              >
                <span className="text-white text-xs truncate">
                  {game.bot_a.tag}
                </span>
                <img
                  src={`/icons/${game.bot_a.character}_${game.bot_a.costume_id}.webp`}
                  alt={game.bot_a.character}
                  className="w-8 h-8"
                />
              </div>

              {/* VS Image */}
              <img
                src="/misc/VS_clear.webp"
                alt="VS"
                className="h-10 object-contain mx-4"
              />

              {/* Bot B */}
              <div
                className="flex items-center  justify-start cursor-pointer gap-x-2 w-36"
                onClick={() => navigate(`/profiles/${game.bot_b.twitch_display_name}/${game.bot_b.tag}`)}
              >
                <img
                  src={`/icons/${game.bot_b.character}_${game.bot_b.costume_id}.webp`}
                  alt={game.bot_b.character}
                  className="w-8 h-8"
                />
                <span className="text-white text-xs truncate">
                  {game.bot_b.tag}
                </span>
              </div>
              <div className="flex items-center justify-end">
                <img
                src={`/stages/STAGE_${game.stage}.webp`}
                alt={game.stage}
                className="w-10 h-10 border border-black rounded-lg"
                />
              </div>

              {/* Result and Duration */}
              <div className="text-center ml-4 w-20">
                <div className={resultStyles[result]}>{result}</div>
                <div className="text-gray-300 text-xs">
                  {formatTimePlayed(game.duration)}
                </div>
              </div>

              {/* Replay Button */}
              <div className="ml-4 flex items-center w-10">
                {game.slp_replay ? (
                  <button
                    onClick={() => handleReplayClick(game.slp_replay)}
                    className="hover:opacity-80 transition-opacity duration-200 ease-in-out"
                  >
                    <img
                      src="/misc/SLP.svg"
                      alt="Replay Available"
                      className="w-6 h-6"
                    />
                  </button>
                ) : (
                  <img
                    src="/misc/SLP.svg"
                    alt="No Replay Available"
                    className="w-6 h-6 opacity-20"
                    title="No replay available"
                  />
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const handleReplayClick = (replayData) => {
  //console.log("Replay data:", replayData);
};

export default GameHistory;
